import React from "react";
import { Button } from "react-bootstrap";

export default function OpenExternalLinkButton({ title, url }) {
  const openInNewTab = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  
  return (
    <div className="float-right">
      <Button title={title} onClick={openInNewTab} variant="info" size="md" className="p-2 text-info btn-link edit">
        <i className="fa fa-link" />
      </Button>
    </div>
  );
}
